import { getSentimentIcon } from './iconMappings';

interface MomentStyling {
  className: string;
  icon?: string;
}

export const getMomentStyling = (
  sentiment_id?: number,
  sentiment?: string,
  includeIcon: boolean = false
): MomentStyling => {
  const isNegative = sentiment_id === 3 || (sentiment && sentiment.toLowerCase() === 'negative');
  const isPositive = sentiment_id === 2 || (sentiment && sentiment.toLowerCase() === 'positive');
  
  const sentimentClass = isNegative ? 'moment-tag-danger' : isPositive ? 'moment-tag-success' : '';
  
  return {
    className: sentimentClass,
    ...(includeIcon && { icon: getSentimentIcon(sentiment) })
  };
};
